import { EntityReport } from "../../entity/EntityReport";

export class DtoReportsPostRes extends EntityReport {}
